import { BranchOfficeRole } from 'types/roles/BranchOfficeRole';
import { useHasBranchOfficeRole } from './use-has-branch-office-role';

export const useIsOgpManager = () => useHasBranchOfficeRole(BranchOfficeRole.MANAGER);
